import { render } from "./wxmp_login.vue?vue&type=template&id=26be8bc2&scoped=true"
import script from "./wxmp_login.vue?vue&type=script&lang=js"
export * from "./wxmp_login.vue?vue&type=script&lang=js"

import "./wxmp_login.vue?vue&type=style&index=0&id=26be8bc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26be8bc2"]])

export default __exports__